export class CryptoJSConfig {
  static getKey(): string {
    return '6SyX1qeZwFedfIFQQG4H+ADNLcUV5wfDlJSf0/0IGW4=';
  }
}
